/* Pricing cards: click a card to select it. Only the selected card shows its
   buttons. Behaves as a radio group so keyboard and screen readers work. */
(function () {
  'use strict';

  function cardsIn(group) {
    return Array.prototype.slice.call(group.querySelectorAll('[data-pricing-card]'));
  }

  function select(group, card, focus) {
    cardsIn(group).forEach(function (el, i) {
      var on = el === card;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.setAttribute('tabindex', on || (!card && i === 0) ? '0' : '-1');
      var ctas = el.querySelector('.pricing-card__ctas');
      if (ctas) {
        if (on) ctas.removeAttribute('hidden');
        else ctas.setAttribute('hidden', '');
      }
    });
    if (focus && card) card.focus();
  }

  function move(group, current, step) {
    var all = cardsIn(group);
    if (!all.length) return;
    var i = all.indexOf(current);
    var next = all[(i + step + all.length) % all.length];
    select(group, next, true);
  }

  function init(group) {
    if (group.dataset.pricingSelectBound) return;
    group.dataset.pricingSelectBound = '1';

    group.addEventListener('click', function (e) {
      // let the real CTA links do their job
      if (e.target.closest('a, button')) return;
      var card = e.target.closest('[data-pricing-card]');
      if (card && group.contains(card)) select(group, card, false);
    });

    group.addEventListener('keydown', function (e) {
      var card = e.target.closest('[data-pricing-card]');
      if (!card) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        select(group, card, false);
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        move(group, card, 1);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        move(group, card, -1);
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pricing-select]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest ? e.target.closest('[data-pricing-card]') : null;
    var group = card && card.closest('[data-pricing-select]');
    if (group) select(group, card, false);
  });
})();
